(function () {
  const Core = window.RB.Core;
  const { equip, empower, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Akali, Silent": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move to a battlefield, give me +2 :rb_might: this turn",
          targets: [],
          program: [buff("source", 2)],
          self: true,
          condSpec: { k: "evToBf" },
        },
      ],
      selfUntargetable: true,
      selfUntargetableCond: { k: "notInCombat" },
    },

    "Field Musicians": {
      play: [buff("$t1", 3)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +3 Might to..." }],
    },

    "Hand Hammer": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["calm"] }),
      ],
      attachedMightSpecs: [{ n: 2, cond: { k: "atBfWithOtherFriendly", n: 1 } }],
    },

    "Nasus, Ascended": {
      triggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, you score 1 point",
          targets: [],
          program: [{ op: "points", n: 1 }],
          selfBf: true,
          you: true,
          condSpec: { k: "selfEmpowered" },
        },
      ],
      abilities: [
        empower({ energy: 8, pips: 0, anyPower: 0, domains: null }),
      ],
    },

    "Serene Ascetic": {
      abilities: [
        empower({ energy: 3, pips: 0, anyPower: 0, domains: null }),
      ],
      selfKwSpecs: [
        { name: "deflect", value: null, cond: { k: "selfEmpowered" } },
        { name: "shield", value: 3, cond: { k: "selfEmpowered" } },
      ],
    },

    "Shen, Scourge of Shadows": {
      triggers: [
        {
          on: "hold",
          optional: false,
          label: "When I hold, if there is exactly one other unit you control here, draw 1",
          targets: [],
          program: [
            {
              op: "if",
              cond: { k: "atBfWithOtherFriendly", n: 1 },
              then: [{ op: "draw", n: 1 }],
            },
          ],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Steel Paws": {
      abilities: [
        empower({ energy: 7, pips: 0, anyPower: 0, domains: null }),
      ],
      selfMightSpecs: [{ n: 7, cond: { k: "selfEmpowered" } }],
    },

    "Twilight Shroud": {
      play: [
        buff("$t1", 1),
        { op: "grant", to: "$t1", untargetable: true, dur: "turn" },
      ],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit", friendly: true },
          prompt: "Give +1 Might to...",
        },
      ],
      flowCost: { energy: 2, pips: 0, anyPower: 0, domains: null },
    },

    "Crumbling Sands": {
      targets: [{
        bind: "t",
        spec: { zone: "chain", kinds: ["spell"] },
        prompt: "Counter which spell?",
      }],
      play: [{
        op: "if",
        cond: { k: "turnFact", key: "spells", who: "opponent", n: 2, cmp: "atLeast" },
        then: [{ op: "counter", to: "$t" }],
      }],
    },

    "Helm of Suppression": {
      abilities: [empower({ energy: 4, pips: 1, anyPower: 0, domains: ["calm"] }, { targets: [] })],
      auraCostMod: [
        {
          who: "enemy",
          what: { type: "spell" },
          cond: { k: "not", cond: { k: "selfEmpowered" } },
          energyMore: 1,
        },
        {
          who: "enemy",
          what: { type: "spell" },
          cond: { k: "selfEmpowered" },
          energyMore: 1,
          powerMore: 1,
        },
      ],
    },

    "Mournful Witness": {
      triggers: [{
        on: "combatEnd",
        condSpec: { k: "inCombat" },
        label: "a combat I was in ended: empower me",
        program: [{ op: "empowerSource" }],
      }],
      selfMightSpecs: [{ n: 2, cond: { k: "selfEmpowered" } }],
    },

    "Resonating Strike": {
      targets: [
        {
          bind: "b",
          spec: { zone: "battlefield", friendly: true },
          prompt: "Move a unit to which battlefield you control?",
        },
        {
          bind: "u",
          spec: { type: "unit", friendly: true },
          prompt: "Move which friendly unit there?",
        },
      ],
      play: [
        { op: "move", to: "$u", destRef: "$b" },
        buff("$u", 2),
      ],
    },

    "Sanction": {
      play: [
        {
          op: "option",
          varKey: "mode",
          prompt: "Choose one",
          options: [
            "Empower a unit. Disempower it at end of turn.",
            "Disempower a unit that's Empowered. Empower it at end of turn.",
          ],
        },
        {
          op: "if",
          cond: { k: "varEq", key: "mode", value: 0 },
          then: [
            { op: "choose", bind: "a", spec: { type: "unit" }, prompt: "Empower which unit?" },
            { op: "empower", to: "$a" },
            {
              op: "delayed",
              on: "endOfTurn",
              carry: ["a"],
              label: "Sanction: disempower at end of turn",
              program: [{ op: "disempower", to: "$a" }],
            },
          ],
          else: [
            { op: "choose", bind: "b", spec: { type: "unit" }, prompt: "Disempower which Empowered unit?" },
            {
              op: "if",
              cond: { k: "targetEmpowered", bind: "b" },
              then: [
                { op: "disempower", to: "$b" },
                {
                  op: "delayed",
                  on: "endOfTurn",
                  carry: ["b"],
                  label: "Sanction: empower at end of turn",
                  program: [{ op: "empower", to: "$b" }],
                },
              ],
            },
          ],
        },
      ],
    },

    "Tomb-Raider Barbara": {
      play: [{
        op: "if",
        cond: { k: "runesAtLeast", n: 7 },
        then: [
          {
            op: "choose",
            bind: "g",
            spec: { type: "gear", enemy: true, attached: true },
            prompt: "Choose an enemy gear",
          },
          {
            op: "if",
            cond: { k: "targetEmpowered", bind: "g" },
            then: [{ op: "disempower", to: "$g" }],
            else: [{ op: "kill", to: "$g" }],
          },
        ],
      }],
    },

    "Curator of the Sands": {
      triggers: [
        {
          on: "played", optional: true, exhaustSelf: true,
          label: "big unit or gear: exhaust me to ready up to 2 runes",
          condSpec: {
            k: "and",
            conds: [
              { k: "evYou" },
              { k: "selfReady" },
              { k: "evCardEnergyAtLeast", n: 7 },
              { k: "or", conds: [{ k: "evType", type: "unit" }, { k: "evType", type: "gear" }] },
            ],
          },
          program: [
            { op: "exhaust", to: "source" },
            {
              op: "choose", bind: "r",
              spec: { type: "rune", friendly: true, ready: false },
              min: 0, max: 2,
              prompt: "Ready up to 2 runes",
            },
            { op: "ready", to: "$r" },
          ],
        },
        {
          on: "chained", optional: true, exhaustSelf: true,
          label: "big activated ability: exhaust me to ready up to 2 runes",
          condSpec: {
            k: "and",
            conds: [{ k: "evControllerYou" }, { k: "selfReady" }, { k: "evAbilityEnergyAtLeast", n: 7 }],
          },
          program: [
            { op: "exhaust", to: "source" },
            {
              op: "choose", bind: "r",
              spec: { type: "rune", friendly: true, ready: false },
              min: 0, max: 2,
              prompt: "Ready up to 2 runes",
            },
            { op: "ready", to: "$r" },
          ],
        },
      ],
    },

    "Siphoning Strike": {
      targets: [
        {
          bind: "t", spec: { type: "unit", atBf: true },
          prompt: "Deal 4 to which unit at a battlefield?",
        },
      ],
      play: [
        {
          op: "delayed", on: "dies", carry: ["t"],
          label: "Siphoning Strike: channel 1 rune exhausted",
          program: [
            { op: "if", cond: { k: "targetDead", bind: "t" }, skip: 1 },
            { op: "channel", n: 1, exhausted: true },
          ],
        },
        {
          op: "if", cond: { k: "runesAtLeast", n: 7 },
          then: [{ op: "deal", to: "$t", n: 7 }],
          else: [{ op: "deal", to: "$t", n: 4 }],
        },
      ],
    },

    "Eye of Twilight": {
      abilities: [
        {
          label: "Give a friendly unit [Tank] this turn",
          exhausts: true,
          action: true,
          targets: [
            {
              bind: "t", spec: { type: "unit", friendly: true },
              prompt: "Give which friendly unit [Tank] this turn?",
            },
          ],
          program: [{ op: "grant", to: "$t", keyword: "tank", dur: "turn" }],
        },
      ],
    },

    "Shadow Dash": {
      targets: [
        { bind: "e", spec: { type: "unit", enemy: true }, prompt: "Move which enemy unit?" },
        {
          bind: "d", spec: { type: "unit", friendly: true, atBf: true },
          prompt: "Send it to the battlefield of which friendly unit?",
        },
      ],
      play: [
        { op: "move", to: "$e", destRef: "$d" },
        {
          op: "if",
          cond: {
            k: "count",
            spec: { type: "unit", friendly: true, sameLocAs: "d", ignoreUntargetable: true },
            n: 2, cmp: "exactly",
          },
          then: [
            {
              op: "grant",
              spec: { type: "unit", friendly: true, sameLocAs: "d", ignoreUntargetable: true },
              might: 1, dur: "turn",
            },
          ],
        },
      ],
      flowCost: { energy: 5, pips: 0, anyPower: 2, domains: null },
    },

    "Decree of Focus": {
      targets: [{
        bind: "t",
        spec: {
          orSpecs: [
            { type: "unit", friendly: true, inCombatWithDomain: "fury" },
            { type: "unit", friendly: true, chosenByEnemyDomain: "fury" },
          ],
        },
        prompt: "Give which friendly unit +4 Might this turn?",
      }],
      play: [buff("$t", 4)],
    },

    "Affectionate Poro": {
      triggers: [{
        on: "combatEnd",
        label: "a combat I was in ended and I was never damaged this turn: draw 1",
        condSpec: {
          k: "and",
          conds: [{ k: "selfAtEvBf" }, { k: "not", cond: { k: "selfDamagedThisTurn" } }],
        },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Esteemed Hierophant": {
      damageImmuneCond: { k: "runesAtLeast", n: 7 },
      damageImmuneNonCombat: true,
      damageImmuneFromEnemy: true,
    },

    "Ol' Poro": {
      playCond: { k: "ownTurnsTaken", n: 4 },
    },

    "Frostcoat Mother": {
      abilities: [empower({ energy: 12, pips: 0, anyPower: 0, domains: null })],
      auraCostMod: [{
        ability: { self: true, label: "Empower" },
        energyLess: { count: { type: "rune", friendly: true } },
      }],
      selfMightSpecs: [{ n: 3, cond: { k: "selfEmpowered" } }],
    },

    "Pakaa Protector": {
      triggers: [{
        on: "move", self: true,
        label: "reveal the top card: draw it if it is a unit, else trash it for +2 Might",
        program: [
          {
            op: "lookTopTake", n: 1, public: true, take: "hand", restTo: "trash",
            filter: { type: "unit" }, varKey: "pp",
            prompt: "Draw the revealed unit",
          },
          {
            op: "if", cond: { k: "varEq", key: "pp", value: 0 },
            then: [buff("source", 2)],
          },
        ],
      }],
    },

    "Sandstone Chimera": {
      capChannelPhase: true,
    },

    "Riven, Shattered": {
      triggers: [{
        on: "attack", self: true,
        label: "deal 2 to an enemy unit here for each Equipment attached to me",
        targets: [{
          bind: "t", spec: { type: "unit", enemy: true, here: true },
          prompt: "Deal damage to which enemy unit here?",
        }],
        program: [{
          op: "deal", to: "$t",
          n: { count: { attached: true, attachedToSource: true, equipment: true }, times: 2 },
        }],
      }],
    },

    "Astral Heron": {
      triggers: [{
        on: "finalizedCard",
        label: "your first card each turn: your next card costs less",
        condSpec: {
          k: "and",
          conds: [{ k: "evYou" }, { k: "playedExactly", n: 1 }, { k: "selfAtBf" }],
        },
        program: [{ op: "nextPlayMod", cardType: "any", mod: "costLess", n: 2, power: 2 }],
      }],
    },
  });
})();
